import { AvatarMenuComponent } from './avatar-menu/avatar-menu.component';
import { LayoutComponent } from './layout/layout.component';
import { RightSidenavComponent } from './right-sidenav/right-sidenav.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { TaskListComponent } from './task-list/task-list.component';

import { ToolbarComponent } from './toolbar/toolbar.component';

// Non-standalone components that need to be declared in the module
export const components: any[] = [
  LayoutComponent,
  SidenavComponent,
  ToolbarComponent,
  AvatarMenuComponent,
];

export const standaloneComponents = [RightSidenavComponent, TaskListComponent];

export * from './avatar-menu/avatar-menu.component';
export * from './layout/layout.component';
export * from './right-sidenav/right-sidenav.component';
export * from './sidenav/sidenav.component';
export * from './task-list/task-list.component';
export * from './toolbar/toolbar.component';
